import { SlashCommand } from './types';

export const dictionaryCommands: SlashCommand[] = [
    { id: 'define', name: 'Urban Dictionary', trigger: '/define', description: 'Look up slang terms', category: 'Research', icon: 'fa-book', mode: 'tool', tool: 'dictionary', prefix: 'urban dictionary slang for: ', integration: 'Dictionary' }
];
